import type { ReactNode } from 'react'

import { Badge, Tooltip, type StatusTone } from '@aeris/ui'

/**
 * O selo que se explica — F156.
 *
 * *"Convertido é o quê? Faturado o quê?"* — a interface não respondia isso em
 * lugar nenhum: nenhum tooltip, nenhuma legenda, nenhum glossário, e a ficha do
 * documento nem exibia a situação. A pessoa aprendia pelo nome do selo, e pelo
 * menos um dos nomes estava errado.
 *
 * ## Recebe o META já resolvido, não o código
 *
 * Assim serve Vendas, Compras e Financeiro sem virar um `switch` por módulo —
 * cada um tem o seu registro (`*-status-meta.tsx`), com as suas situações, e
 * este componente só sabe desenhar.
 *
 * ## O texto continua sendo o sinal primário
 *
 * O tooltip é REFORÇO. `docs/UI_UX.md` exige que situação nunca dependa só da
 * cor, e uma explicação que só existe no hover não existe para quem usa o
 * sistema pelo teclado nem para quem está no celular. Por isso o rótulo está
 * sempre no DOM, por isso há ícone, e por isso a mesma frase aparece na legenda
 * da barra, na ficha do documento e no glossário.
 *
 * ## Por que o `<span>` com `tabIndex`
 *
 * O `Badge` é um `<span>` e não recebe foco. O tooltip do Radix abre no hover
 * **e no foco** — sem um alvo focável, quem navega por teclado nunca alcança a
 * explicação.
 *
 * Não confundir com `components/platform-account-status.tsx`, que tem um
 * `StatusBadge` próprio: aquele é a saúde de uma conta da plataforma, e não
 * tem nada a ver com a situação de um documento.
 */

export type DocumentStatusBadgeProps = {
  meta: {
    readonly label: string
    readonly tone: StatusTone
    readonly icon: ReactNode
    readonly what: string
  }
  className?: string
}

export const DocumentStatusBadge = ({
  meta,
  className,
}: DocumentStatusBadgeProps): ReactNode => (
  <Tooltip content={meta.what} side="top">
    <span tabIndex={0} className="inline-flex rounded-(--radius-full)">
      <Badge
        tone={meta.tone}
        icon={meta.icon}
        {...(className ? { className } : {})}
      >
        {meta.label}
      </Badge>
    </span>
  </Tooltip>
)
